var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEntrepriseEnDifficult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58 50",
    style: {
      enableBackground: "new 0 0 58 58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000132809132925729181710000014790092108623348628_);}\r\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 33.9721,
    cy: -82.5995,
    r: 25.919,
    gradientTransform: "matrix(-0.983 -0.1838 0.1838 -0.983 76.7072 -54.566)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3DEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    style: {
      stopColor: "#F3DEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    style: {
      stopColor: "#E5C6A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5799,
    style: {
      stopColor: "#D5A983"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7632,
    style: {
      stopColor: "#A57B5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8977,
    style: {
      stopColor: "#D5A983"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.01,27.91c0.04,0.01,0.08,0,0.13,0l6.72-0.38c0.39-0.02,0.69-0.36,0.67-0.75c-0.02-0.39-0.36-0.69-0.75-0.67 l-4.97,0.28c7.28-9.03,20.28-13.65,33.69-11.85c0.19,0.02,0.37-0.03,0.53-0.15c0.15-0.11,0.25-0.29,0.27-0.48 c0.05-0.39-0.22-0.74-0.61-0.8C32.88,11.28,19.41,16,11.75,25.45l-0.16-5.01l0,0c-0.02-0.39-0.34-0.69-0.74-0.69 c-0.39,0.02-0.69,0.34-0.69,0.73l0.22,6.73C10.39,27.58,10.67,27.87,11.01,27.91L11.01,27.91z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000120528447911391921860000007597261762729974973_",
    cx: 29.5,
    cy: 26.6864,
    r: 31.6946,
    gradientTransform: "matrix(1 0 0 -1 0 60)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3DEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    style: {
      stopColor: "#F3DEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    style: {
      stopColor: "#E5C6A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5799,
    style: {
      stopColor: "#D5A983"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7632,
    style: {
      stopColor: "#A57B5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8977,
    style: {
      stopColor: "#D5A983"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120528447911391921860000007597261762729974973_)"
    },
    d: "M41.49,18.9c-0.39,0-0.71,0.32-0.71,0.71 v26.68h-2.67v-20c0-0.19-0.08-0.37-0.21-0.5c-0.13-0.13-0.32-0.21-0.5-0.21h-5.83c-0.39,0-0.71,0.32-0.71,0.71v20h-2.68V30.1 c0-0.39-0.32-0.71-0.71-0.71h-5.84c-0.39,0-0.71,0.32-0.71,0.71v16.19h-2.67V32.43c0-0.39-0.32-0.71-0.71-0.71H11.7 c-0.39,0-0.71,0.32-0.71,0.71v13.86H9.6c-0.19,0-0.37,0.07-0.51,0.21c-0.13,0.13-0.21,0.32-0.21,0.51s0.08,0.37,0.21,0.5 c0.13,0.13,0.32,0.21,0.5,0.21h39.82c0.39,0,0.71-0.32,0.71-0.71c0-0.19-0.07-0.37-0.21-0.5c-0.13-0.13-0.31-0.21-0.5-0.21h-1.39 V19.61c0-0.39-0.32-0.71-0.71-0.71H41.49z M42.2,20.32h4.41v25.97H42.2V20.32z M32.27,27h4.41v19.29h-4.41 C32.27,46.29,32.27,27,32.27,27z M22.34,30.82h4.41v15.47h-4.41V30.82z M12.41,33.14h4.41v13.15h-4.41V33.14z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrepriseEnDifficult);
export default __webpack_public_path__ + "static/media/entreprise-en-difficulté.8a267c2cdee7bfc1ecda1af4903d820e.svg";
export { ForwardRef as ReactComponent };